<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <b-container>
    <b-row>
      <b-col
        class="d-flex justify-content-center align-items-center"
        sm="12"
        md="6"
      >
        <b-img :src="require('@/assets/images/pages/coming-soon.svg')" />
      </b-col>
      <b-col
        sm="12"
        md="6"
      >
        <b-card>
          <b-card-title>
            {{ $t('editProductTag') }}
          </b-card-title>
          <validation-observer ref="formValidation">
            <b-form @submit.prevent="validateForm()">
              <b-form-group label="Nombre">
                <validation-provider
                  #default="{ errors }"
                  name="Nombre de la etiqueta"
                  rules="required"
                >
                  <b-form-input v-model="productTag.name" autocomplete="off" type="text" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-button type="submit">
                {{ $t('edit') }}
              </b-button>
            </b-form>
          </validation-observer>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import {
  BRow,
  BCol,
  BButton,
  BImg,
  BForm,
  BFormGroup,
  BCard,
  BCardTitle,
  BContainer,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BButton,
    BImg,
    BForm,
    BFormGroup,
    BCard,
    BCardTitle,
    BContainer,
  },
  data() {
    return {
      required,
      productTag: {
        name: '',
      },
    }
  },

  created() {
    this.fetchProductTag({ productTagId: this.$route.params.productTagId }).then(
      response => {
        this.productTag = response
      },
    )
  },

  methods: {
    ...mapActions('productTags', ['fetchProductTag', 'editProductTag']),
    validateForm() {
      this.$refs.formValidation.validate().then(success => {
        if (success) {
          this.editProductTag(this.productTag)
            .then(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('productTagEdited'),
                  icon: 'EditIcon',
                  variant: 'success',
                },
              })
            })
            .then(() => {
              this.$router.push({ name: 'product-tags' })
            })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
